import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "min-h-screen bg-gradient-to-br from-[#F8FAFF] to-[#F0F7FF] dark:from-[#0a0a0a] dark:to-[#1a1a1a] p-6" }
const _hoisted_2 = { class: "max-w-7xl mx-auto" }
const _hoisted_3 = { class: "flex items-center justify-between mb-8" }
const _hoisted_4 = { class: "text-3xl font-bold bg-gradient-to-r from-[#1a1a1a] to-[#666666] dark:from-white dark:to-[#cccccc] bg-clip-text text-transparent" }
const _hoisted_5 = { class: "text-[#666666] dark:text-[#cccccc] mt-2" }
const _hoisted_6 = {
  key: 0,
  class: "flex flex-col items-center justify-center py-20"
}
const _hoisted_7 = { class: "mt-6 text-lg font-medium text-[#666666] dark:text-[#cccccc]" }
const _hoisted_8 = {
  key: 1,
  class: "flex flex-col items-center justify-center py-20"
}
const _hoisted_9 = { class: "text-2xl font-bold text-[#1a1a1a] dark:text-white mb-2" }
const _hoisted_10 = { class: "text-[#666666] dark:text-[#cccccc] text-center max-w-md" }
const _hoisted_11 = {
  key: 2,
  class: "flex flex-col items-center justify-center py-20"
}
const _hoisted_12 = { class: "text-2xl font-bold text-[#1a1a1a] dark:text-white mb-2" }
const _hoisted_13 = { class: "text-[#666666] dark:text-[#cccccc] text-center max-w-md" }
const _hoisted_14 = {
  key: 3,
  class: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8"
}
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "relative overflow-hidden rounded-t-3xl aspect-square bg-gradient-to-br from-[#F8FAFF] to-[#E6F3FF] dark:from-[#0c1427] dark:to-[#1a2642]" }
const _hoisted_17 = ["src", "alt"]
const _hoisted_18 = {
  key: 0,
  class: "absolute top-4 right-4 bg-gradient-to-r from-[#FF3B30] to-[#FF2D92] text-white px-3 py-1 rounded-full text-sm font-bold shadow-lg"
}
const _hoisted_19 = { class: "absolute bottom-4 right-4 opacity-0 group-hover:opacity-100 transform translate-y-4 group-hover:translate-y-0 transition-all duration-300" }
const _hoisted_20 = ["href"]
const _hoisted_21 = { class: "p-6 flex-1 flex flex-col" }
const _hoisted_22 = { class: "text-lg font-bold text-[#1a1a1a] dark:text-white mb-3 line-clamp-2 group-hover:text-[#007AFF] transition-colors duration-300" }
const _hoisted_23 = { class: "flex items-center justify-between" }
const _hoisted_24 = { class: "flex items-center gap-3" }
const _hoisted_25 = { class: "text-2xl font-bold bg-gradient-to-r from-[#007AFF] to-[#5856D6] bg-clip-text text-transparent" }
const _hoisted_26 = {
  key: 0,
  class: "text-sm text-[#666666] dark:text-[#cccccc] line-through"
}
const _hoisted_27 = { class: "flex items-center gap-1" }
const _hoisted_28 = { class: "flex flex-wrap gap-2 mt-4" }
const _hoisted_29 = { class: "px-3 py-1 bg-gradient-to-r from-[#34C759]/10 to-[#22C55E]/10 text-[#34C759] dark:text-[#22C55E] text-xs font-medium rounded-full border border-[#34C759]/20" }
const _hoisted_30 = { class: "px-3 py-1 bg-gradient-to-r from-[#FF9500]/10 to-[#FFB020]/10 text-[#FF9500] dark:text-[#FFB020] text-xs font-medium rounded-full border border-[#FF9500]/20" }
const _hoisted_31 = { class: "border-t border-[#E5E7EB] dark:border-[#374151] px-6 py-4 bg-gradient-to-r from-[#F8FAFF] to-[#F0F7FF] dark:from-[#0c1427] dark:to-[#1a2642]" }
const _hoisted_32 = { class: "flex items-center justify-between" }
const _hoisted_33 = { class: "flex items-center gap-2" }
const _hoisted_34 = { class: "text-xs text-[#666666] dark:text-[#cccccc]" }
const _hoisted_35 = { class: "text-[#007AFF] hover:text-[#0056CC] text-sm font-medium transition-colors duration-200" }
const _hoisted_36 = {
  key: 4,
  class: "mt-12"
}
const _hoisted_37 = { class: "bg-white dark:bg-[#1a1a1a] rounded-3xl shadow-xl border border-[#E5E7EB] dark:border-[#374151] p-8" }
const _hoisted_38 = { class: "flex flex-col sm:flex-row items-center justify-between gap-6" }
const _hoisted_39 = { class: "flex items-center gap-4" }
const _hoisted_40 = { class: "text-lg font-bold text-[#1a1a1a] dark:text-white" }
const _hoisted_41 = { class: "text-sm text-[#666666] dark:text-[#cccccc]" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Pagination = _resolveComponent("Pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, [
          _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.directT('ecommerce.productsGrid.title') || 'רשת מוצרים'), 1),
          _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.directT('ecommerce.productsGrid.subtitle') || 'נהל וצפה בקטלוג המוצרים שלך'), 1)
        ]),
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.navigateToCreateProduct && _ctx.navigateToCreateProduct(...args))),
          class: "group flex items-center gap-3 px-6 py-3 bg-gradient-to-r from-[#007AFF] to-[#5856D6] text-white rounded-2xl font-semibold shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105 hover:from-[#0056CC] hover:to-[#4A47B8]"
        }, [
          _cache[2] || (_cache[2] = _createElementVNode("div", { class: "w-5 h-5 rounded-lg bg-white/20 flex items-center justify-center" }, [
            _createElementVNode("i", { class: "material-symbols-outlined text-sm" }, "add")
          ], -1)),
          _createElementVNode("span", null, _toDisplayString(_ctx.directT('ecommerce.productsGrid.addNewProduct') || 'הוסף מוצר חדש'), 1),
          _cache[3] || (_cache[3] = _createElementVNode("i", { class: "material-symbols-outlined text-sm group-hover:translate-x-1 transition-transform duration-300" }, "arrow_forward", -1))
        ])
      ]),
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _cache[4] || (_cache[4] = _createElementVNode("div", { class: "relative" }, [
              _createElementVNode("div", { class: "w-16 h-16 border-4 border-[#007AFF]/30 border-t-[#007AFF] rounded-full animate-spin" }),
              _createElementVNode("div", {
                class: "absolute inset-0 w-16 h-16 border-4 border-transparent border-r-[#34C759] rounded-full animate-spin",
                style: {"animation-delay":"-0.3s"}
              })
            ], -1)),
            _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.directT('ecommerce.productsGrid.loadingProducts') || 'טוען מוצרים...'), 1)
          ]))
        : (_ctx.allProducts && _ctx.allProducts.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _cache[5] || (_cache[5] = _createElementVNode("div", { class: "w-24 h-24 bg-gradient-to-br from-[#007AFF] to-[#5856D6] rounded-3xl flex items-center justify-center mb-6 shadow-xl" }, [
                _createElementVNode("i", { class: "material-symbols-outlined text-white text-5xl" }, "inventory_2")
              ], -1)),
              _createElementVNode("h3", _hoisted_9, _toDisplayString(_ctx.directT('ecommerce.productsGrid.noProductsTitle') || 'אין מוצרים'), 1),
              _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.directT('ecommerce.productsGrid.noProductsFound') || 'לא נמצאו מוצרים במאגר'), 1)
            ]))
          : (_ctx.allProducts && _ctx.allProducts.length > 0 && _ctx.products && _ctx.products.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _cache[6] || (_cache[6] = _createElementVNode("div", { class: "w-24 h-24 bg-gradient-to-br from-[#FF9500] to-[#FFB020] rounded-3xl flex items-center justify-center mb-6 shadow-xl" }, [
                  _createElementVNode("i", { class: "material-symbols-outlined text-white text-5xl" }, "search_off")
                ], -1)),
                _createElementVNode("h3", _hoisted_12, _toDisplayString(_ctx.directT('ecommerce.productsGrid.noResultsTitle') || 'אין תוצאות'), 1),
                _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.directT('ecommerce.productsGrid.noResultsFound') || 'לא נמצאו מוצרים התואמים לחיפוש'), 1)
              ]))
            : (_ctx.products && _ctx.products.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.products, (product) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: product.id,
                      onClick: ($event: any) => (_ctx.navigateToEdit(product.id)),
                      class: "group bg-white dark:bg-[#1a1a1a] rounded-3xl shadow-lg hover:shadow-2xl border border-[#E5E7EB] dark:border-[#374151] overflow-hidden cursor-pointer transition-all duration-500 hover:-translate-y-2 hover:scale-[1.02] flex flex-col"
                    }, [
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("img", {
                          src: product.image_link,
                          alt: product.title,
                          class: "w-full h-full object-cover transition-transform duration-700 group-hover:scale-110",
                          onerror: "this.src='/images/placeholder-product.png'"
                        }, null, 8, _hoisted_17),
                        _cache[8] || (_cache[8] = _createElementVNode("div", { class: "absolute inset-0 bg-gradient-to-t from-black/20 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" }, null, -1)),
                        (product.compare_at_price && product.compare_at_price > product.price)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_18, " -" + _toDisplayString(Math.round(((product.compare_at_price - product.price) / product.compare_at_price) * 100)) + "% ", 1))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_19, [
                          _createElementVNode("a", {
                            href: product.product_link,
                            target: "_blank",
                            onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"])),
                            class: "w-12 h-12 bg-gradient-to-br from-[#007AFF] to-[#5856D6] text-white rounded-2xl flex items-center justify-center shadow-xl hover:shadow-2xl transition-all duration-300 hover:scale-110"
                          }, _cache[7] || (_cache[7] = [
                            _createElementVNode("i", { class: "material-symbols-outlined text-xl" }, "shopping_cart", -1)
                          ]), 8, _hoisted_20)
                        ]),
                        _cache[9] || (_cache[9] = _createElementVNode("div", {
                          class: "absolute bottom-4 left-4 opacity-0 group-hover:opacity-100 transform translate-y-4 group-hover:translate-y-0 transition-all duration-300",
                          style: {"transition-delay":"0.1s"}
                        }, [
                          _createElementVNode("button", { class: "w-12 h-12 bg-white/90 dark:bg-black/90 text-[#1a1a1a] dark:text-white rounded-2xl flex items-center justify-center shadow-xl hover:shadow-2xl transition-all duration-300 hover:scale-110" }, [
                            _createElementVNode("i", { class: "material-symbols-outlined text-xl" }, "visibility")
                          ])
                        ], -1))
                      ]),
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("h3", _hoisted_22, _toDisplayString(product.title), 1),
                        _createElementVNode("div", _hoisted_23, [
                          _createElementVNode("div", _hoisted_24, [
                            _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.formatPrice(product.price)), 1),
                            (product.compare_at_price && product.compare_at_price > product.price)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(_ctx.formatPrice(product.compare_at_price)), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_27, [
                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (i) => {
                              return _createElementVNode("div", {
                                class: "flex",
                                key: i
                              }, _cache[10] || (_cache[10] = [
                                _createElementVNode("i", { class: "material-symbols-outlined text-[#FFD700] text-sm" }, "star", -1)
                              ]))
                            }), 64)),
                            _cache[11] || (_cache[11] = _createElementVNode("span", { class: "text-xs text-[#666666] dark:text-[#cccccc] ml-1" }, "(4.8)", -1))
                          ])
                        ]),
                        _cache[12] || (_cache[12] = _createElementVNode("div", { class: "flex-1" }, null, -1)),
                        _createElementVNode("div", _hoisted_28, [
                          _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.directT('ecommerce.productsGrid.inStock')), 1),
                          _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.directT('ecommerce.productsGrid.fastShipping')), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_31, [
                        _createElementVNode("div", _hoisted_32, [
                          _createElementVNode("div", _hoisted_33, [
                            _cache[13] || (_cache[13] = _createElementVNode("div", { class: "w-2 h-2 bg-[#34C759] rounded-full animate-pulse" }, null, -1)),
                            _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.directT('ecommerce.productsGrid.active')), 1)
                          ]),
                          _createElementVNode("button", _hoisted_35, _toDisplayString(_ctx.directT('ecommerce.productsGrid.editProduct')) + " ← ", 1)
                        ])
                      ])
                    ], 8, _hoisted_15))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
      (_ctx.products && _ctx.products.length > 0 && _ctx.totalProducts > _ctx.pageSize)
        ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("div", _hoisted_38, [
                _createElementVNode("div", _hoisted_39, [
                  _cache[14] || (_cache[14] = _createElementVNode("div", { class: "w-12 h-12 bg-gradient-to-br from-[#007AFF] to-[#5856D6] rounded-2xl flex items-center justify-center" }, [
                    _createElementVNode("i", { class: "material-symbols-outlined text-white text-xl" }, "apps")
                  ], -1)),
                  _createElementVNode("div", null, [
                    _createElementVNode("p", _hoisted_40, _toDisplayString(_ctx.directT('ecommerce.productsGrid.totalProducts', { count: _ctx.totalProducts })), 1),
                    _createElementVNode("p", _hoisted_41, _toDisplayString(_ctx.directT('ecommerce.productsGrid.showingProducts', { from: Math.min(_ctx.pageSize * _ctx.currentPage, _ctx.totalProducts), total: _ctx.totalProducts })), 1)
                  ])
                ]),
                _createVNode(_component_Pagination, {
                  items: _ctx.pageSize,
                  total: _ctx.totalProducts,
                  current: _ctx.currentPage,
                  onPageChange: _ctx.handlePageChange,
                  class: "pagination-enhanced"
                }, null, 8, ["items", "total", "current", "onPageChange"])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}